import { cleanString } from '@utilities/attachments';

export const siteSearchData = ({ site, inputValue }) => {
  const { dataPointsForSearch = [], dataPoints = [], name, title, siteAreaName = '' } = site;

  const dataPointsCombine = [...dataPointsForSearch, ...dataPoints];

  const dataPointsObject = dataPointsCombine?.reduce(
    (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
    {}
  );
  const filterObject = {
    name,
    title,
    siteAreaName,
    ...dataPointsObject
  };
  const cleanInput = cleanString(inputValue);

  if (
    !Object.values(filterObject).some((value) => {
      return cleanString(String(value)).includes(cleanInput);
    })
  )
    return false;

  return true;
};
